export default __webpack_public_path__ + "static/media/steam.edfe4a4c.png";